import React from 'react'
import PropTypes from 'prop-types'

import RoundIcon from '../../../../shared/settings/round-icon'
import styles from '../payment.css'
import addIcon from '../../../../../../images/add-to-list.svg'

const AddIcon = React.memo(({
  onClick, onMouseOver, isDisabled, id
}) => {
  return (
    <div
      className={styles.addButton}
      onClick={onClick}
      onMouseOver={onMouseOver}
      id={id}
    >
      Add
      <RoundIcon alt="Add Icon" src={addIcon} disabled={isDisabled} />
    </div>
  )
})

AddIcon.propTypes = {
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onMouseOver: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired
}

export default AddIcon
